export const PAYMENT_VALIDATION_KEY = "PAYUTSP20221234$";